type Columns = Record<string, any>;

export const processColumns = (columns: Columns): Columns => {
  const updatedColumns: Columns = { ...columns };

  delete updatedColumns['id'];

  Object.keys(updatedColumns).forEach((key) => {
    const column = updatedColumns[key];

    if (column?.switchboard !== undefined) {
      delete updatedColumns[key];
      updatedColumns[`${key}_switchboard`] = '';
    } else if (column?.multiSwitchboard !== undefined) {
      delete updatedColumns[key];
      updatedColumns[`${key}_multiswitchboard`] = '';
    } else {
      updatedColumns[`${key} (${column?.fieldType || 'unknown'})`] = '';
      delete updatedColumns[key];
    }
  });

  return updatedColumns;
};
